import { render, staticRenderFns } from "./productTag.vue?vue&type=template&id=61a74395&"
import script from "./productTag.vue?vue&type=script&lang=js&"
export * from "./productTag.vue?vue&type=script&lang=js&"
import style0 from "./productTag.vue?vue&type=style&index=0&id=61a74395&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports